export default __webpack_public_path__ + "static/media/backoffice.97005c6b.png";